import { ITrialClass } from '@wot/typings';
import { parseISO } from 'date-fns';
import { format } from 'date-fns/esm';
import Chip from '../../../../components/Chip';
import { TableRowItemData } from '../../../../components/Table';

export default function TableRowItem({ session }: { session: ITrialClass }) {
  return (
    <>
      <TableRowItemData text={format(parseISO(session.createdAt), 'dd/MM/yyyy')} />
      <TableRowItemData text={session._id} />
      <TableRowItemData text={session?.user?.name || ''} />
      {/* <TableRowItemData text={session?.user?.email || ""} /> */}
      <TableRowItemData text={session.category.name} />
      <TableRowItemData text={session.user.email} />
      <TableRowItemData text={session?.tutor?.name || ''} />
      <TableRowItemData text={session.type} />
      <TableRowItemData
        component={
          <Chip
            state={
              session.dispute?.status === 'active'
                ? 'warning'
                : session.dispute?.status === 'resolved'
                ? 'success'
                : 'pending'
            }
          >
            <p className="text-sm font-semibold capitalize">{session.dispute?.status}</p>
          </Chip>
        }
      />
    </>
  );
}
